import { PageContainer, PageHeader } from '@/components/layout/PageHeader';
import { UsersPanel } from '@/features/users/UsersPanel';
import { useCurrentUser } from '@/lib/auth/session';

/** Equipe Fluxus (T-026c): administradores e consultores, geridos na organização Fluxus. */
export function EquipeFluxusPage() {
  const user = useCurrentUser();
  return (
    <PageContainer className="max-w-5xl">
      <PageHeader
        title="Equipe Fluxus"
        description="Administradores e consultores da Fluxus. Consultores acessam só as empresas em que estão alocados; administradores, todas."
      />
      <UsersPanel organizationId={user.organization.id} team />
    </PageContainer>
  );
}
